<template>
  <a-layout class='index animated fadeIn s_bf'>
    <a-form class="p-t-20" ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <div class="s_ptb0lr24 s_bf">
        <div class="s_bor10 s_bor_cbed s_over_h mb25">
          <p class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_ali s_font_b s_bf58 s_c333">小程序设置</p>
          <div class="s_p24">
            <a-form-item ref="store_code" label="小程序AppID" name="store_code" :rules="[{ required: true, message: '请输入小程序AppID' ,pattern:RegExp(/\d/)}]">
              <a-input v-model:value="form.app_id" placeholder='请输入小程序AppID' />
            </a-form-item>
            <a-form-item ref="store_code" label="AppSecret 小程序密钥" name="store_code" :rules="[{ required: true, message: '请输入小程序密钥',pattern:RegExp(/\d/)}]">
              <a-input v-model:value="form.app_secret" placeholder='请输入小程序密钥' />
            </a-form-item>
            <a-form-item :wrapper-col="{offset:5}" name="store_code">
              <a-button type="primary" @click="onSubmit">提交</a-button>
            </a-form-item>
          </div>
          <!--   <p class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_ali s_font_b s_bf58 s_c333">微信支付设置</p>
        <div class="s_p24">
          <a-form-item ref="store_code" label="微信支付商户号MCHID" name="store_code" >
            <a-input v-model:value="form.store_code" placeholder='请输入微信支付商户号MCHID'/>
          </a-form-item>
          <a-form-item ref="store_code" label="微信支付密钥APIKEY" name="store_code" >
            <a-input v-model:value="form.store_code" placeholder='请输入微信支付密钥APIKEY'/>
          </a-form-item>
          <a-form-item ref="store_code" label="apiclient_cert.pem" name="store_code" >
            <a-textarea v-model:value="form.store_code" :rows="4" placeholder='请输入微信支付密钥APIKEY'/>
          </a-form-item>
          <a-form-item ref="store_code" label="apiclient_key.pem" name="store_code" >
            <a-textarea v-model:value="form.store_code" :rows="4" placeholder='请输入微信支付密钥APIKEY'/>
          </a-form-item>
        </div>
        <p class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_ali s_font_b s_bf58 s_c333">服务器域名</p>
        <div class="s_p24">
          <div class="s_bor10 s_bor_cbed s_over_h mb25">
            <div class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_bian_c s_font_b s_bf58 s_c333">
              <p class="width43 text-ac">服务器配置</p><p class="width33 text-ac">说明</p><p class="width23 text-ac">操作</p>
            </div>
            <div class="s_flex_bian_c">
              <div class="width77">
                <div class="s_flex_bian_c p-t-15 p-b-15">
                  <div class="width55">
                    <div class="s_flex_ali">
                      <p class="width40 text-ac">request合法域名</p>
                      <div class="width60">
                        <p class="s_lin_h33">https://oss.72ma.cn</p>
                        <p class="s_lin_h33">https://oss.72ma.cn</p>
                        <p class="s_lin_h33">https://oss.72ma.cn</p>
                      </div>
                    </div>
                  </div>
                  <div class="text-ac width45">说明说明</div>
                </div>
                <div class="s_flex_bian_c p-t-15 p-b-15">
                  <div class="width55">
                    <div class="s_flex_ali">
                      <p class="width40 text-ac">socket合法域名</p>
                      <div class="width60">
                        <p class="s_lin_h33">https://oss.72ma.cn</p>
                        <p class="s_lin_h33">https://oss.72ma.cn</p>
                        <p class="s_lin_h33">https://oss.72ma.cn</p>
                      </div>
                    </div>
                  </div>
                  <div class="text-ac width45">说明说明</div>
                </div>
                <div class="s_flex_bian_c p-t-15 p-b-15">
                  <div class="width55">
                    <div class="s_flex_ali">
                      <p class="width40 text-ac">uploadFile合法域名</p>
                      <div class="width60">
                        <p class="s_lin_h33">https://oss.72ma.cn</p>
                        <p class="s_lin_h33">https://oss.72ma.cn</p>
                        <p class="s_lin_h33">https://oss.72ma.cn</p>
                      </div>
                    </div>
                  </div>
                  <div class="text-ac width45">说明说明</div>
                </div>
                <div class="s_flex_bian_c p-t-15 p-b-15">
                  <div class="width55">
                    <div class="s_flex_ali">
                      <p class="width40 text-ac">downloadFile合法域名</p>
                      <div class="width60">
                        <p class="s_lin_h33">https://oss.72ma.cn</p>
                        <p class="s_lin_h33">https://oss.72ma.cn</p>
                        <p class="s_lin_h33">https://oss.72ma.cn</p>
                      </div>
                    </div>
                  </div>
                  <div class="text-ac width45">说明说明</div>
                </div>
                <div class="s_flex_bian_c p-t-15 p-b-15">
                  <div class="width55">
                    <div class="s_flex_ali">
                      <p class="width40 text-ac">udp合法域名</p>
                      <div class="width60">
                        <p class="s_lin_h33">https://oss.72ma.cn</p>
                        <p class="s_lin_h33">https://oss.72ma.cn</p>
                        <p class="s_lin_h33">https://oss.72ma.cn</p>
                      </div>
                    </div>
                  </div>
                  <div class="text-ac width45">说明说明</div>
                </div>
              </div>
              <div class="width23 text-ac"><a href="javascript:;">修改</a></div>
            </div>
          </div>
        </div>
        <p class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_ali s_font_b s_bf58 s_c333">业务域名</p>
        <div class="s_p24">
          <div class="s_bor10 s_bor_cbed s_over_h mb25">
            <div class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_bian_c s_font_b s_bf58 s_c333">
              <p class="width43 text-ac">域名</p><p class="width33 text-ac">说明</p><p class="width23 text-ac">操作</p>
            </div>
            <div class="s_flex_bian_c p-t-15 p-b-15">
              <div class="width43 text-ac">
                <p class="s_lin_h33">https://oss.72ma.cn</p>
                <p class="s_lin_h33">https://oss.72ma.cn</p>
                <p class="s_lin_h33">https://oss.72ma.cn</p>
              </div>
              <div class="text-ac width33">说明说明</div>
              <div class="width23 text-ac"><a href="javascript:;">修改</a></div>
            </div>
          </div>
        </div>-->
        </div>
        <div class="height-30"></div>
      </div>
    </a-form>
  </a-layout>
</template>

<script>
import { ref, onMounted, reactive, toRefs, inject } from 'vue';
import { iscode } from '@/utils/app';
import { message } from 'ant-design-vue';
import { getWxApplets, setWxApplets } from '@/api/public_wx';
// 初始化默认筛选项数值
let defForm = {
  app_id: '',
  app_secret: '',
};
export default {
  setup() {
    const form = ref({ ...defForm });
    const state = reactive({
      labelCol: { span: 5 },
      wrapperCol: { span: 16 },
    });
    const _lodash = inject('_lodash');
    const onSubmit = async () => {
      const hide = message.loading('正在加载中...', 0);
      let res = await getWxApplets(form.value).then((res) => res.data);
      setTimeout(hide);
    };
    const getWxApplet = async () => {
      let res = await setWxApplets().then((res) => res.data);
    };
    onMounted(() => {
      // getWxApplet();
    });
    return {
      ...toRefs(state),
      form,
      onSubmit,
    };
  },
};
</script>
